module.exports = __webpack_public_path__ + "static/media/coupon.cd00c161.svg";